<template>
  <div class="fixed inset-0 z-20 flex justify-end blur">
    <on-click-outside :handler="closeShoppingBag" class="w-full md:w-1/2 lg:w-1/3 bg-gray-300 opacity-100">
      <div class="flex flex-col justify-between h-full max-h-screen overflow-auto">
        <h2 class="mt-10">
          <div class="flex flex-col">
            <div class="flex items-center mb-3 text-center relative">
              <span class="toggle absolute left-0"
                @click="toggleShoppingBag"
              >
                X
              </span>
              <div class="flex flex-col items-center justify-center w-4/5 mx-auto">
                <h2 class="font-bold text-md uppercase tracking-wide w-4/5">
                {{$t('cart.cart')}}
              </h2>
              </div>
            </div>
            <div class="flex justify-end w-full pr-4 mb-6" v-if="products && products.length>0">
              <button class="bg-white text-xs p-1 px-2 hover:bg-b2c-red-300 rounded hover:text-b2c-grey-100"
                @click="removeAllProducts" >
                  {{$t('cart.clear')}}
              </button>
            </div>
            <div v-else class="mt-10 text-sm italic text-center">
              {{$t('cart.emptyCart')}}
            </div>

          </div>
          <cart-products-list class="px-2"
            :user-options="{
              background: 'bg-gray-200',
            }"
          />
        </h2>
        <section class="mb-2 px-4 text-left" v-if="products.length>0" :aria-label="$t('cart.total')">
          <cart-totals :app-options="{shipping: false}" />
          <button class="w-full border border-gray-800 py-2 hover:text-white hover:bg-b2c-red-300" @click="goToCheckout">
            {{$t('cart.checkout')}}
          </button>
        </section>
      </div>
    </on-click-outside>
  </div>
</template>

<script>
import CartProductsList from '@/components/cart/CartProductsList.vue';
import CartTotals from '@/components/cart/CartTotals.vue';
import OnClickOutside from '@/directives/OnClickOutside';

import { mapGetters, mapActions } from 'vuex';

export default {
  components: { CartProductsList, CartTotals, OnClickOutside },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      products: ['cart/products'],
    }),
  },

  methods: {
    ...mapActions({
      removeAllProducts: 'cart/removeAllProducts',
    }),

    toggleShoppingBag() {
      this.$store.dispatch('toggleShoppingBag');
    },

    closeShoppingBag() {
      this.$store.dispatch('closeShoppingBag');
    },

    goToCheckout() {
      this.toggleShoppingBag();
      return this.$router.push('/checkout').catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  @apply w-1/5 font-bold text-xs p-2 cursor-pointer;
}

.blur {
  backdrop-filter: blur(10px) brightness(75%);
}
</style>
